import { combineReducers } from 'redux';
import authentication from './authen';

export default combineReducers({
  authentication,
});